import axiosHttp from '../hooks/intercepter';
const BASE_URL = process.env.REACT_APP_BASE_URL;

const updateUserOnboardingStatus = async (userId, onboardingData) => {
    return await axiosHttp.patch(`${BASE_URL}/users/${userId}/is-onboarding`, onboardingData);
};

const getUsers = async () => {
    return await axiosHttp.get(`${BASE_URL}/users`);
};

const createUser = async (userData) => {
    return await axiosHttp.post(`${BASE_URL}/users`, userData);
};

const updateUser = async (id, userData) => {
    return await axiosHttp.put(`${BASE_URL}/users/${id}`, userData);
};

// New: fetch all admins for owner dropdown
const getAllAdmin = async () => {
    return await axiosHttp.get(`${BASE_URL}/users/getalladmin`);
};

const updateUserLanguage = async (userId, languageData) => {
    return await axiosHttp.put(`${BASE_URL}/users/${userId}/language`, languageData);
};

export { updateUserOnboardingStatus, getUsers, createUser, updateUser, getAllAdmin, updateUserLanguage }; 